export default __webpack_public_path__ + "static/media/SEO.25ed6b63.jpg";